export default (props = {}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"{...props}><path fill="currentColor" d="M6 12.5v-1h12v1z"/></svg>